"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _antd = require("antd");

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ProgressBar(_ref) {
  var size = _ref.size,
      type = _ref.type,
      current = _ref.current,
      children = _ref.children;
  var hasBarsType = type === _constants.PROGRESS_BAR_TYPE_BARS;
  var isSmall = size === _constants.PROGRESS_BAR_SIZE_SMALL;
  var title = children[current].props.title;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "ant-steps-wrapper"
  }, isSmall && title, /*#__PURE__*/_react.default.createElement(_antd.Steps, {
    className: hasBarsType ? 'ant-steps-type-bars' : null,
    size: size,
    current: current,
    labelPlacement: "vertical"
  }, children));
}

ProgressBar.propTypes = {
  /** The index of current step in progress bar */
  current: _propTypes.default.number,

  /** @ignore */
  children: _propTypes.default.node,

  /** The size progress bar, by default is big */
  size: _propTypes.default.oneOf(_constants.PROGRESS_BAR_SIZES),

  /** The type progress bar, by default is 'dots' */
  type: _propTypes.default.oneOf(_constants.PROGRESS_BAR_TYPES)
};
ProgressBar.defaultProps = {
  current: null,
  children: null,
  size: _constants.PROGRESS_BAR_SIZE_DEFAULT,
  type: _constants.PROGRESS_BAR_TYPE_DOTS
};
var _default = ProgressBar;
exports.default = _default;